import moment from "moment";

export const API_KEY = '9afb64b56f9ecfee4d9c5911234e518d';

export function saveWeather (data, databaseName, latitude, longitude) {
  const weatherName = getWeatherStorageName(databaseName, latitude, longitude);

  localStorage.setItem(weatherName, JSON.stringify({
    data,
    expiredAt: moment().add(1, 'hours'),
  }));
}

export function getRestoredWeather (databaseName, latitude, longitude) {
  const weatherName = getWeatherStorageName(databaseName, latitude, longitude);
  let savedWeather = null;
  try {
    savedWeather = JSON.parse(localStorage.getItem(weatherName));
  } catch (e) {
    savedWeather = null;
  }

  if (savedWeather && moment(savedWeather.expiredAt) > moment()) {
    return savedWeather.data;
  }

  return null;
}

function getWeatherStorageName (databaseName, latitude, longitude) {
  const shortLat = latitude.toFixed(1);
  const shortLong = longitude.toFixed(1);

  return `${databaseName}-${shortLat}-${shortLong}`;
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/weather.js